import { Box, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import { EMPTY_PLACEHOLDER } from '../wingmanIntelligenceMetrics';

const ACCENT_BLUE = '#1E88E5';

const WingmanInsightsFooter = ({ whatHappened = EMPTY_PLACEHOLDER, nextSteps = [] }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
        gap: 2,
        mt: 2,
      }}
    >
      <Box
        sx={{
          p: 2,
          borderRadius: 2,
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'rgba(0, 0, 0, 0.08)',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.25 }}>
          <SearchIcon sx={{ fontSize: 22, color: '#5F6368' }} />
          <Typography
            sx={{
              fontSize: 15,
              fontWeight: 700,
              color: '#1B1B1F',
              letterSpacing: '-0.01em',
            }}
          >
            What happened?
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: 13,
            fontWeight: 400,
            color: '#5F6368',
            lineHeight: 1.55,
          }}
        >
          {whatHappened}
        </Typography>
      </Box>

      <Box
        sx={{
          p: 2,
          borderRadius: 2,
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'rgba(0, 0, 0, 0.08)',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.25 }}>
          <LightbulbOutlinedIcon sx={{ fontSize: 22, color: ACCENT_BLUE }} />
          <Typography
            sx={{
              fontSize: 15,
              fontWeight: 700,
              color: ACCENT_BLUE,
              letterSpacing: '-0.01em',
            }}
          >
            What should we do next?
          </Typography>
        </Box>
        {nextSteps.length === 0 ? (
          <Typography sx={{ fontSize: 13, color: '#5F6368' }}>{EMPTY_PLACEHOLDER}</Typography>
        ) : (
          <Box
            component="ul"
            sx={{
              m: 0,
              pl: 2.25,
              color: ACCENT_BLUE,
              '& li': {
                fontSize: 13,
                fontWeight: 400,
                lineHeight: 1.5,
                mb: 0.75,
                '&:last-child': { mb: 0 },
              },
            }}
          >
            {nextSteps.map((step, index) => (
              <Box component="li" key={`${index}-${step}`}>
                {step}
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default WingmanInsightsFooter;
